import React, { useState, useEffect } from 'react';
import BaseModal from './common/BaseModal';

const AddCompModal = ({ isOpen, onClose, onSave, initialData }) => {
  const [streetAddress, setStreetAddress] = useState('');
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [link, setLink] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  const formatPrice = (value) => {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');
    // Format with commas
    return digits.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const [price, setPrice] = useState('');

  useEffect(() => {
    if (initialData) {
      setStreetAddress(initialData.streetAddress || '');
      setCity(initialData.city || '');
      setState(initialData.state || '');
      setZipCode(initialData.zipCode || '');
      setLink(initialData.link || '');
      setPrice(initialData.price ? formatPrice(initialData.price.toString()) : '');
    } else {
      setStreetAddress('');
      setCity('');
      setState('');
      setZipCode('');
      setLink('');
      setPrice('');
    }
  }, [initialData, isOpen]);

  const handlePriceChange = (e) => {
    const rawValue = e.target.value;
    const formattedValue = formatPrice(rawValue);
    setPrice(formattedValue);
  };

  const handleSubmit = async () => {
    setIsSaving(true);
    const fullAddress = [streetAddress, city, state, zipCode].filter(Boolean).join(', ');
    
    try {
      await onSave({
        fullAddress,
        streetAddress,
        city,
        state,
        zipCode,
        link,
        price: Number(price.replace(/\D/g, '')),
        createdAt: initialData?.createdAt || new Date().toISOString()
      });
      onClose();
    } catch (error) {
      console.error('Error saving comp:', error);
    } finally {
      setIsSaving(false);
    }
  };

  const footer = (
    <div className="d-flex justify-content-end gap-2">
      <button 
        className="btn btn-secondary" 
        onClick={onClose}
        disabled={isSaving}
      >
        Cancel
      </button>
      <button 
        className="btn btn-primary" 
        onClick={handleSubmit}
        disabled={!streetAddress || !city || !state || !zipCode || !price || isSaving}
      >
        {isSaving ? (
          <>
            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            Saving...
          </>
        ) : (
          initialData ? 'Save Changes' : 'Add Comp'
        )}
      </button>
    </div>
  );

  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      title={initialData ? "Edit Market Comparable" : "Add Market Comparable"}
      maxWidth="500px"
      footer={footer}
    >
      <div className="mb-3">
        <label className="form-label">Street Address <span className="text-danger">*</span></label>
        <input
          type="text"
          className="form-control bg-dark text-white border-secondary"
          value={streetAddress}
          onChange={(e) => setStreetAddress(e.target.value)}
          placeholder="123 Main St"
          required
        />
      </div>

      <div className="row g-3 mb-3">
        <div className="col-md-6">
          <label className="form-label">City <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control bg-dark text-white border-secondary"
            value={city}
            onChange={(e) => setCity(e.target.value)}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">State <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control bg-dark text-white border-secondary"
            value={state}
            onChange={(e) => setState(e.target.value)}
            placeholder="NY"
            maxLength={2}
            required
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">ZIP Code <span className="text-danger">*</span></label>
          <input
            type="text"
            className="form-control bg-dark text-white border-secondary"
            value={zipCode}
            onChange={(e) => setZipCode(e.target.value)}
            placeholder="12345"
            maxLength={5}
            required
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Price <span className="text-danger">*</span></label>
        <div className="input-group">
          <span className="input-group-text bg-dark text-white border-secondary">$</span>
          <input
            type="text"
            className="form-control bg-dark text-white border-secondary"
            value={price}
            onChange={handlePriceChange}
            required
          />
        </div>
      </div>

      <div className="mb-3">
        <label className="form-label">Link</label>
        <input
          type="url"
          className="form-control bg-dark text-white border-secondary"
          value={link}
          onChange={(e) => setLink(e.target.value)}
          placeholder="https://www.zillow.com/..."
        />
      </div>
    </BaseModal>
  );
};

export default AddCompModal;
